import React from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router';
import Dashboard from '@material-ui/icons/Dashboard';
import {makeStyles} from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import {Link as RouterLink} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import HomeIcon from '@material-ui/icons/Home';
import ListItemText from '@material-ui/core/ListItemText';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ForumIcon from '@material-ui/icons/Forum';
import MessageIcon from '@material-ui/icons/Message';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PeopleIcon from '@material-ui/icons/People';
import KeyboardIcon from '@material-ui/icons/Keyboard';
const useStyles = makeStyles(theme => ({
	drawer: {
		width: theme.spacing(7) + 1,
		flexShrink: 0,
		whiteSpace: 'nowrap',
	},
	drawerPaper: {
		width: theme.spacing(7) + 1,
		overflowX: 'hidden',
	},
	list: {
		height: '100%',
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	toolbar: theme.mixins.toolbar,
}));

const AlterDrawer = ({auth}) => {
	const classes = useStyles();

	const location = useLocation();

	return (
		<Drawer
			className={classes.drawer}
			variant='permanent'
			classes={{
				paper: classes.drawerPaper,
			}}
		>
			<div className={classes.toolbar} />

			<div className={classes.list}>
				{auth.isAuth && (
					<>
						<List>
							<ListItem button selected={location.pathname === '/'} component={RouterLink} to={'/'}>
								<ListItemIcon>
									<HomeIcon />
								</ListItemIcon>
								<ListItemText primary={'Home'} />
							</ListItem>
							<ListItem
								button
								selected={location.pathname === '/chat'}
								component={RouterLink}
								to={'/chat'}
							>
								<ListItemIcon>
									<ForumIcon />
								</ListItemIcon>
								<ListItemText primary={'Chat'} />
							</ListItem>
							<ListItem
								button
								selected={location.pathname === '/door'}
								component={RouterLink}
								to={'/door'}
							>
								<ListItemIcon>
									<MeetingRoomIcon />
								</ListItemIcon>
								<ListItemText primary={'Door'} />
							</ListItem>
							<ListItem
								button
								selected={location.pathname === '/keypad'}
								component={RouterLink}
								to={'/keypad'}
							>
								<ListItemIcon>
									<KeyboardIcon />
								</ListItemIcon>
								<ListItemText primary={'Keypad Code'} />
							</ListItem>
							<ListItem
								button
								selected={location.pathname === '/users'}
								component={RouterLink}
								to={'/users'}
							>
								<ListItemIcon>
									<PeopleIcon />
								</ListItemIcon>
								<ListItemText primary={'Members'} />
							</ListItem>
						</List>
						<Divider />

						<List>
							<ListItem
								button
								selected={location.pathname === '/article/add'}
								component={RouterLink}
								to={'/article/add'}
							>
								<ListItemIcon>
									<AddBoxIcon />
								</ListItemIcon>
								<ListItemText primary={'Add article'} />
							</ListItem>

							<ListItem
								button
								selected={location.pathname === '/messages'}
								component={RouterLink}
								to={'/messages'}
							>
								<ListItemIcon>
									<MessageIcon />
								</ListItemIcon>
								<ListItemText primary={'Messages'} />
							</ListItem>
						</List>
					</>
				)}

				{auth.isAdmin && (
					<>
						<Divider />

						<List>
							<ListItem
								button
								selected={location.pathname === '/admin/dashboard'}
								component={RouterLink}
								to={'/admin/dashboard'}
							>
								<ListItemIcon>
									<Dashboard />
								</ListItemIcon>
								<ListItemText primary={'Dashboard'} />
							</ListItem>
							<ListItem
								button
								selected={location.pathname === '/admin/users'}
								component={RouterLink}
								to={'/admin/users'}
							>
								<ListItemIcon>
									<PeopleIcon />
								</ListItemIcon>
								<ListItemText primary={'All Users'} />
							</ListItem>
							<ListItem
								button
								selected={location.pathname === '/admin/addUser'}
								component={RouterLink}
								to={'/admin/addUser'}
							>
								<ListItemIcon>
									<PersonAddIcon />
								</ListItemIcon>
								<ListItemText primary={'Add User'} />
							</ListItem>
						</List>
					</>
				)}
			</div>
		</Drawer>
	);
};

AlterDrawer.propTypes = {
	auth: PropTypes.shape({
		isAuth: PropTypes.bool,
		isAdmin: PropTypes.bool,
	}),
};

export default AlterDrawer;
